import _ from 'lodash'
import React from 'react'
import Copy from 'components/Copy'
import Layout from 'components/Layout'
import Text from 'components/Text'
import styles from './Home.module.scss'

export default function Home() {
  return (
    <Layout className="Home">
      <div style={{ lineHeight: 1.125 }}>
        <Text element="h1" size="xxlarge">
          <a href="https://instagram.com/savior.tattoo">
            <Text element="u">
              Savior
            </Text>
          </a>
          {' '}
          is an independent tattoo shop
          <br className={styles.break} />
          {' '}
          on
          {' '}
          <a href="https://www.google.com/maps/dir//Savior+Tattoo,+439+Monroe+Ave+Suite+2,+Rochester,+NY+14607">
            <Text element="u">
              Monroe Ave.
            </Text>
          </a>
          {' '}
          specializing in all styles.
        </Text>
        <br />
        <br />
        <Text element="h2">
          <a href="https://www.google.com/maps/dir//Savior+Tattoo,+439+Monroe+Ave+Suite+2,+Rochester,+NY+14607">
            439 Monroe Ave.
            <br />
            Rochester, NY
          </a>
        </Text>
        <Text element="h2">
          <a href="https://instagram.com/savior.tattoo">
            @savior.tattoo
          </a>
          <br />
          <a href="mailto:hello@saviortattoo.com">
            hello@saviortattoo.com
          </a>
          <br />
          <a href="tel:+15855633678">
            585-563-3678
          </a>
        </Text>
        <br />
        <Text element="h2">
          feat.<br />
          <Copy columns={2} className={styles.artists}>
            <a href="https://www.instagram.com/worldwar_pork/">
              Christine Erickson
            </a>
            <br />
            <a href="https://www.instagram.com/stab_itha/">
              Stabitha
            </a>
            <br />
            <a href="https://www.instagram.com/ga.tattoos/">
              Gabe Arias
            </a>
            <br />
            <a href="https://www.instagram.com/leemilestattoo/">
              Lee Miles
            </a>
            <br />
            <a href="https://www.instagram.com/hannah.tattoo/">
              Hannah Bostick
            </a>
            <br />
            <a href="https://www.instagram.com/bennsavi/">
              Bennett Savino
            </a>
          </Copy>
        </Text>
      </div>
    </Layout>
  )
}